import { useState } from "react";
import { useSelector } from "react-redux";


import EyeIcon from "../../Components/Icon-SVG/EyeIcon";
import EyeCloseIcon from "../../Components/Icon-SVG/EyeCloseIcon";
import CopyIcon from "../../Components/Icon-SVG/CopyIcon";
import CopyButton from "../../Components/common/CopyButton/CopyButton";

import Spinner from "../../Components/common/Spinner/Spinner";

import { truncateValue, maskValue } from "./SystemInfo";

const Unique = () => {

  const uniqueId = useSelector((state) => state.settings.uniqueId);
  const uniqueIdLoading = useSelector((state) => state.settings.uniqueIdLoading);

  const [showUniqueId, setShowUniqueId] = useState(false);

  const toggleShowUniqueId = () => {
    setShowUniqueId((prevState) => !prevState);
  };

  return (
    <div className="system-info__create flex-1">
      <h3>Unique ID</h3>
      <div className="system-info__secret">
        <span>ID |</span>
        <span className="system-info__secret__text" title={uniqueId}>
          {showUniqueId ? truncateValue(uniqueId) : maskValue(uniqueId)}
        </span>
        {uniqueIdLoading ? (
          <span className="system-info__secret__action">
            <Spinner width={12} height={12} />
          </span>
        ) : uniqueId === "" ? (
          <span style={{ color: "#e65555" }}>Error fetching unique id !</span>
        ) : (
          <>
            {showUniqueId && (
              <span className="system-info__secret__action">
                <CopyButton
                  title="Copy unique id"
                  itemToCopy={uniqueId}
                  icon={CopyIcon}
                  iconWidth={16}
                  iconHeight={16}
                  successMessage="Unique ID copied"
                  failureMessage="Copy failed"
                />
              </span>
            )}
            <span
              className="system-info__secret__action"
              title={showUniqueId ? "Hide unique id" : "Show unique id"}
              onClick={toggleShowUniqueId}>
              {showUniqueId ? <EyeCloseIcon /> : <EyeIcon />}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default Unique;
